import { colors } from '@smartsheet/lodestar-core';
import { Icon } from '@smartsheet/lodestar-icons';
import React, { useState } from 'react';
import { Handle, NodeProps, Position } from 'react-flow-renderer';
import { NODE_HEIGHT } from '../../../../utils/dimensions';
import { TriggerIcon } from '../../../icons/TriggerIcon';
import { IconBox, Label, Node } from './styled';

// A Trigger only has a source handle
export const Trigger = ({ selected }: NodeProps) => {
  const [hover, setHover] = useState<boolean>(false);

  return (
    <Node
      selected={selected}
      onMouseOver={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <IconBox color={colors.neutralDark30} hover={hover}>
        <Icon svgComponent={TriggerIcon} size={'xxSmall'} />
      </IconBox>
      <Label selected={selected}>Trigger</Label>
      <Handle
        type="source"
        position={Position.Bottom}
        isConnectable={true}
        style={{ visibility: 'hidden', left: NODE_HEIGHT / 2 }}
      />
    </Node>
  );
};
